;$(function(){
	// 频道页tab切换
	if($('.J_cat_tab').length){
		$('.J_cat_tab').find('span').on('click', function(){
			if($(this).hasClass('active')) return
			$(this).addClass('active').siblings('span').removeClass('active');
			let card = $(this).data('card');
			$(`.${card}`).fadeIn().siblings('.J_cat_card').hide();
		});
	}
	// 翻牌效果
	if($('.J_flip').length){
		$('.J_flip').on({
			mouseenter: function(){
				$(this).css('transform', 'rotateY(180deg)');
				$(this).find(".J_zm").addClass("zhanbu-lingqian__card--zm")
			},
			mouseleave: function(){
				$(this).css('transform', 'rotateY(0deg)');
				$(this).find(".J_zm").removeClass("zhanbu-lingqian__card--zm")
			},
		})
	}
});
